export const GET_LOGS = 'logs/list/get';
export const GET_REQUESTS = 'requests/list/get';
export const GET_REPORTS = 'reports/list/get';
export const GET_NOT_FOUND = 'notfound/list/get';
export const UPDATE_NOT_FOUND_FIXED = 'notfound/id/update';